module.exports = "https://static.energy5.com/_next/static/images/effortlessDesktop-8b0b7d2978c9508300b16ce0e03a3737.png";